import $ from 'jquery';
export default (props, e) => {
	e.preventDefault();
	if ($(e.target).closest('.nav-item-content-nav__item').hasClass('sub-opened')) {
		$('.header .nav-item-content-nav__item.sub-opened').removeClass('sub-opened');
	} else {
		$('.header .nav-item-content-nav__item').removeClass('sub-opened');
		$(e.target).closest('.nav-item-content-nav__item').addClass('sub-opened');
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/headerSubNavDropdownHandler.js